import React from 'react';
const InnerBanner = () => {
  return (  
    <section className="inner-banner">
    <div className="inner-layer">
      <div className="container">
      </div>
    </div>
  </section>
  );
}
 
export default InnerBanner;